// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CAnimal_abstract } from './../abstract/SagaSchema/CAnimal_abstract';
export class CAnimal extends CAnimal_abstract {
  static formsProperties = {
    info: ['Race', 'Identification', 'Proprietor', 'Text']
  };
}
